import { tamarackAPI, processApiResponse } from "./Tamarack";

export const AssetDataAPI = {
  async addAsset(data) {
    const path = `asset`;
    const response = await tamarackAPI.post(path, data);
    return processApiResponse(response, "post", path);
  },
  async getAssetDocuments(assetId, email) {
    const path = `asset/${assetId}/documents`;
    tamarackAPI.setHeader("broker-id", "ALL");
    tamarackAPI.setHeader("email", email);
    const response = await tamarackAPI.get(path);
    return processApiResponse(response, "get", path);
  },
  async updateAsset(data) {
    const path = `asset`;
    const response = await tamarackAPI.put(path, data);
    return processApiResponse(response, "put", path);
  },
  async deleteAsset(assetId) {
    const path = `asset/${assetId}`;
    const response = await tamarackAPI.delete(path);
    return processApiResponse(response, "delete", path);
  },
  async getAssetTypes(searchObj) {
    if (searchObj && typeof searchObj !== "object") {
      throw new Error(
        "Search object must be key value type ex: {active: 'true'}"
      );
    }
    let searchCriteria = "";
    if (searchObj) {
      let keys = Object.keys(searchObj);
      searchCriteria = `?${keys[0]}=${searchObj[keys[0]]}`;
      for (let i = 1; i < keys.length; i++) {
        searchCriteria = `${searchCriteria}&${keys[i]}=${searchObj[keys[i]]}`;
      }
    }
    const path = `assetTypes${searchCriteria}`;
    const response = await tamarackAPI.get(path);
    return processApiResponse(response, "get", path);
  },
};
